<template>
  <div
    :class="`${sizeClass}`"
    class="select-none flex-shrink-0 flex items-center justify-center rounded-full border border-solid border-grey-300"
    draggable="false"
    :style="{ backgroundColor: config.background, color: config.text }"
  >
    {{ initials }}
  </div>
</template>

<script>
export default {
  name: 'AvatarPlaceholder',
  props: {
    size: {
      type: String,
      validator(size) {
        return ['large', 'medium', 'small'].indexOf(size) !== -1;
      },
      default: 'small',
    },
    initials: {
      type: String,
      required: true,
    },
    config: {
      type: Object,
      required: true,
      validator(obj) {
        return obj?.background && obj?.text;
      },
    },
  },
  computed: {
    sizeClass() {
      return {
        large: 'w-12 h-12 text-init',
        medium: 'w-10 h-10 text-sm',
        small: 'w-8 h-8 text-xs',
      }[this.size];
    },
  },
};
</script>
